import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { ListRequest } from "@/services/backend/omni/offer/api/offer-api";
import { OfferSetupDropdown } from "@/services/backend/omni/offer/components/offer-setup-dropdown";
import { wrhOfferSetupDropdownConfig } from "@/services/backend/omni/servicekindrules/wrh-offer-setup-dropdown-config";
import {
  OfferTable,
  OfferTableFilters,
} from "@/services/backend/omni/offer/components/offer-table";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { WrhBreadcrumbs } from "../../_components/wrh-breadcrumbs";

export function OfferIndexPage() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data: process } = useProcessesProcessShowQuery({ id: processId! });
  const [request, setRequest] = useState<ListRequest>({
    serviceKind: { active: true, values: [GSMServiceKind.WRH] },
    process: { active: true, values: [processId!] },
    customer: { active: false, values: [] },
    state: { active: false, values: [] },
    orderBy: [{ field: "date" }],
    limit: 50,
    offset: 0,
  });

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!process) return null;

  const breadcrumbs = (
    <WrhBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Angebote")}</BreadcrumbPage>
      </BreadcrumbItem>
    </WrhBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Angebote")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <OfferTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <OfferSetupDropdown
                processId={process.id}
                config={wrhOfferSetupDropdownConfig}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <OfferTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
